import createAPIComponent from 'vue-create-api'

export default function createAPI (Vue, Component, events, single) {
  Vue.use(createAPIComponent, {componentPrefix: 'cube-'})
  const api = Vue.createAPI(Component, events, single)
  return api
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/common/helpers/create-api.js